import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import img from "../assets/img.png";
import logo from "../assets/logo.png";
import {
  setAuth,
  useLazyMeQuery,
  useLoginMutation,
} from "../redux/auth/authService";
const Login = ({ showLogin, setShowLogin }) => {
  const [login] = useLoginMutation();
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [me] = useLazyMeQuery();
  const handleLogin = async () => {
    const dataToSend = { identifier: email, password };

    try {
      const response = await login(dataToSend);
      if (response.error) {
        toast.error("Email ou mot de passe incorrect.");
        return;
      }
      const data = response.data;
      localStorage.setItem("auth", JSON.stringify(response.data));

      await me()
        .unwrap()
        .then((response) => {
          console.log("me", response);
          if (response.error) {
            toast.error(
              "Erreur lors de la récupération des données utilisateur."
            );
            return;
          }

          const authData = response;
          localStorage.setItem(
            "auth",
            JSON.stringify({ ...data, ...authData })
          );
          dispatch(setAuth(authData));
        });
      const user = response.data.user;

      const authData = response.data;

      // localStorage.setItem("auth", JSON.stringify(authData));
      // dispatch(setAuth(authData));

      toast.success("Vous êtes connecté.");
      navigate("/dashboard");
    } catch (error) {
      console.error("Erreur lors de la connexion :", error);
      toast.error("Une erreur est survenue. Veuillez réessayer.");
    }
  };

  return (
    <>
      <div className="min-h-screen bg-gray-100 text-gray-900 flex justify-center">
        <div className="max-w-screen-xl m-0 sm:m-10 bg-white shadow sm:rounded-lg flex justify-center flex-1">
          <div className="lg:w-1/2 xl:w-5/12 p-6 sm:p-12">
            <div className="mb-12 flex flex-col items-center">
              <img src={logo} className="w-mx-auto md:w-52" alt="Logo" />
            </div>
            <div className="mt-12 flex flex-col items-center">
              <div className="w-full flex-1 mt-8">
                <div className="mx-auto max-w-xs">
                  <input
                    className="w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white"
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <input
                    className="w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white mt-5"
                    type="password"
                    placeholder="Mot de passe"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <button
                    onClick={handleLogin}
                    className="mt-5 tracking-wide font-semibold bg-primary/70 text-white w-full py-4 rounded-lg hover:bg-primary transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none">
                    <svg
                      className="w-6 h-6 -ml-2"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round">
                      <path d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
                      <circle cx="8.5" cy="7" r="4" />
                      <path d="M20 8v6M23 11h-6" />
                    </svg>
                    <span className="ml-2">Se connecter</span>
                  </button>

                  <p className="mt-6 text-xs text-gray-600 text-center">
                    J’accepte de respecter les{" "}
                    <a
                      href="#"
                      className="border-b m-1 border-gray-500 border-dotted">
                      conditions d'utilisation
                    </a>{" "}
                    et la{" "}
                    <a
                      href="#"
                      className="border-b ml-1 border-gray-500 border-dotted">
                      politique de confidentialité
                    </a>
                    .
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex-1 bg-[#52789f] text-center hidden lg:flex">
            <div
              className="m-12 xl:m-16 w-full bg-contain bg-center bg-no-repeat"
              style={{
                backgroundImage: `url(${img})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
